import { useCallback, useState } from 'react';

export const useContactFieldRow = () => {
  const [copyStatus, setCopyStatus] = useState<Record<string, boolean>>({});

  const onCopy = useCallback((value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      setCopyStatus({ [value]: true });
    });
    setTimeout(() => {
      setCopyStatus({ [value]: false });
    }, 2000);
  }, []);

  return {
    copyStatus,
    onCopy,
  };
};
